/**
 * Shared client-side state that remembers the 1-based list position a product
 * was shown at when the user clicked through from a list / carousel.
 * The PDP `view_item` tracker reads this to populate `index`.
 *
 * Origin `page_section` is captured separately by the `pdp-origin-section`
 * router plugin and accessed via `getOriginSection`.
 */
export function useViewItemPosition() {
  const positions = useState<Record<string, number>>('view-item-positions', () => ({}))
  // Section of the page the user navigated from when entering a PDP.
  // Set by the pdp-origin-section plugin before the new route resolves.
  const originSection = useState<string | undefined>('view-item-origin-section', () => undefined)

  function rememberPosition(idExternal: string, position: number) {
    positions.value[idExternal] = position
  }

  function getPosition(idExternal: string): number {
    return positions.value[idExternal] ?? 1
  }

  function setOriginSection(section: string | undefined) {
    originSection.value = section
  }

  function getOriginSection(): string | undefined {
    return originSection.value
  }

  return { rememberPosition, getPosition, setOriginSection, getOriginSection }
}
